import { styled } from '@mui/material/styles'
import type { ReactNode } from 'react'
import { Box } from '../../../../components/Box.tsx'

interface CountdownCircleProps {
	color: string
	ringColor: string
	percentElapsed: number
	children?: ReactNode
}

const Container = styled(Box)<{ color: string }>(({ color }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	position: 'relative',
	backgroundColor: 'white',
	borderRadius: '50%',
	color: color,
}))

const Conical = styled(Box)({
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 24,
	height: 24,
	borderRadius: '50%',
	backgroundSize: '100% 100%',
})

const ConicalCover = styled(Box)({
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	borderRadius: '50%',
	width: 18,
	height: 18,
	backgroundColor: 'white',
})

const Content = styled(Box)({
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	zIndex: 1,
	width: '100%',
	height: '100%',
})

export const CountdownCircle = ({ color, ringColor, percentElapsed, children }: CountdownCircleProps) => {
	return (
		<Container color={color}>
			<Conical
				sx={{
					backgroundImage: `conic-gradient(${ringColor} ${Math.round(360 * (percentElapsed * 0.01))}deg, transparent 0deg)`,
				}}
			/>
			<ConicalCover />
			<Content>{children}</Content>
		</Container>
	)
}

export const Circle = ({ color, children }: { color: string; children?: ReactNode }) => {
	return (
		<Container color='white'>
			<Content sx={{ backgroundColor: color, w: 24, h: 24, borderRadius: '100%' }}>{children}</Content>
		</Container>
	)
}
